// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".md-reader code,.md-reader mark{margin:0 4px;display:inline-block;padding:0px 5px;font-size:12px;border-radius:3px;height:18px;line-height:18px}.md-reader code{color:#3890ff;background-color:#e6effb}.md-reader mark{background:yellowgreen;color:#5e6d82}.md-reader ol{padding:2px 0 2px 16px}.md-reader hr{margin:2px 0}.md-reader a{color:#3890ff}.md-reader thead th{text-align:left}.md-reader td{max-width:250px;padding-right:10px}\n", ""]);
// Exports
module.exports = exports;
